export default __webpack_public_path__ + "static/media/glovo-sm.f1957109.svg";